export default "__VITE_ASSET__mBE6D7Gq__"